import api from './api'
import { API_ENDPOINTS } from '../config/api'

const fixturesService = {
  // skipLoader: the header polls this in the background
  get: async () => {
    const response = await api.get(API_ENDPOINTS.FIXTURES, { skipLoader: true })
    return response.data
  },
  // owner-only: { sportid, ename, start_time: 'YYYY-MM-DDTHH:mm', eid? }
  addManual: async (data) => {
    const response = await api.post(`${API_ENDPOINTS.FIXTURES}/manual`, data)
    return response.data
  },
  deleteManual: async (id) => {
    const response = await api.delete(`${API_ENDPOINTS.FIXTURES}/manual/${id}`)
    return response.data
  },
}

export default fixturesService
